(function () {
  'use strict';

  var CACHE_TTL_MS = 60 * 1000;

  function formatPrice(value, preformatted) {
    if (preformatted) return preformatted;
    if (value == null || value === '') return '';
    if (typeof value === 'number') return '₹' + Math.round(value);
    if (typeof value === 'string') {
      var stripped = value.replace(/,/g, '').trim();
      if (/^\d+(\.\d+)?$/.test(stripped)) return '₹' + Math.round(parseFloat(stripped));
    }
    return String(value);
  }

  function getPrice(product) {
    if (!product) return '';
    return formatPrice(product.price, product.priceFormatted);
  }

  function getComparePrice(product) {
    if (!product) return '';
    var raw = product.compareAtPrice != null ? product.compareAtPrice
            : product.compare_at_price != null ? product.compare_at_price
            : product.mrp != null ? product.mrp
            : product.originalPrice != null ? product.originalPrice
            : null;
    var formatted = product.compareAtPriceFormatted || product.compare_at_price_formatted || product.mrpFormatted;
    var out = formatPrice(raw, formatted);
    var cur = getPrice(product);
    if (!out || out === cur) return '';
    return out;
  }

  function productImage(product, fallback) {
    if (!product) return fallback || '';
    return product.imageSrc || product.image || product.imageUrl || product.featuredImage || product.featured_image || fallback || '';
  }

  // "gid://shopify/ProductVariant/46713238061304" -> "46713238061304".
  // Passes through plain numeric ids; returns null when there's no id.
  function gidToId(gid) {
    if (gid == null) return null;
    if (typeof gid === 'number') return gid;
    var m = String(gid).match(/(\d+)\s*$/);
    return m ? m[1] : null;
  }

  function extractHandleFromPaths(paths) {
    if (!paths) return null;
    var list = Array.isArray(paths) ? paths : [paths];
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      if (typeof p !== 'string') continue;
      var m = p.match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    }
    return null;
  }

  // Resolve a purchasable variant id for the product.
  // 1. Use an explicit variantId if the API / PDP provided one.
  // 2. Otherwise fetch /products/{handle}.js and pick the first available
  //    variant (or the first variant if none report availability), caching
  //    the result on the product object so repeat clicks don't refetch.
  function getVariantId(product) {
    if (!product) return Promise.resolve(null);
    if (product.variantId) return Promise.resolve(product.variantId);
    if (product._variantIdPromise) return product._variantIdPromise;
    if (!product.handle) return Promise.resolve(null);

    var p = fetch('/products/' + encodeURIComponent(product.handle) + '.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('product fetch failed: ' + r.status);
      return r.json();
    }).then(function (data) {
      var variants = (data && data.variants) || [];
      var chosen = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i] && variants[i].available) { chosen = variants[i]; break; }
      }
      if (!chosen && variants.length) chosen = variants[0];
      var id = chosen ? chosen.id : null;
      if (id) product.variantId = id;
      return id;
    }).catch(function (err) {
      log('shoppable-videos resolve variant:', err);
      product._variantIdPromise = null; // allow a retry on next click
      return null;
    });

    product._variantIdPromise = p;
    return p;
  }

  function addToCart(variantId) {
    var body = {
      items: [{ id: variantId, quantity: 1 }],
      sections: 'mini-cart,cart-icon-bubble,mobile-cart-icon-bubble',
      sections_url: window.location.pathname
    };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/add failed: ' + r.status);
      return r.json();
    });
  }

  // Best-effort cart drawer hookup. Themes wire carts differently, so this
  // tries a few common elements and silently no-ops if none match — the
  // dispatched `cart:refresh` event is the primary integration signal.
  function openCartDrawer(parsedState) {
    var miniCart = document.querySelector('mini-cart');
    if (miniCart && typeof miniCart.renderContents === 'function') {
      try { miniCart.renderContents(parsedState); return true; } catch (e) { log('mini-cart renderContents:', e); }
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.openMenuDrawer === 'function') {
      try { drawer.openMenuDrawer(); return true; } catch (e) {}
    }
    var trigger = document.querySelector('.cart-drawer-container');
    if (trigger && trigger.firstElementChild) {
      trigger.firstElementChild.click();
      return true;
    }
    return false;
  }

  function log() {
    if (window.console && console.error) console.error.apply(console, arguments);
  }

  function debug() {
    if (window.console && console.log) {
      var args = ['[shoppable-videos]'].concat(Array.prototype.slice.call(arguments));
      console.log.apply(console, args);
    }
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function cacheKey(ctx, targetId) {
    return 'bv:shoppable-videos:' + ctx + ':' + (targetId || '');
  }

  function readCache(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.t || Date.now() - parsed.t > CACHE_TTL_MS) {
        sessionStorage.removeItem(key);
        return null;
      }
      return parsed.d;
    } catch (e) {
      return null;
    }
  }

  function writeCache(key, data) {
    try {
      sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: data }));
    } catch (e) {
      /* quota exceeded — ignore */
    }
  }

  function fetchVideos(baseUrl, shopDomain, ctx, targetId) {
    var key = cacheKey(ctx, targetId);
    var cached = readCache(key);
    if (cached) return Promise.resolve(cached);

    var url = baseUrl.replace(/\/$/, '') + '/api/v1/shoppable-videos?context=' + encodeURIComponent(ctx);
    if (ctx !== 'homepage' && targetId) {
      url += '&targetId=' + encodeURIComponent(targetId);
    }

    return fetch(url, {
      method: 'GET',
      headers: { 'X-Shop-Domain': shopDomain, 'Accept': 'application/json' },
      credentials: 'omit'
    }).then(function (res) {
      if (!res.ok) {
        throw new Error('Shoppable videos request failed: ' + res.status);
      }
      return res.json();
    }).then(function (json) {
      var list = (json && json.data) || [];
      writeCache(key, list);
      return list;
    });
  }

  // Display name: show only the first two words of the product title.
  // e.g. "UNTAMED Men - 100ml" -> "UNTAMED Men"
  function displayTitle(title) {
    if (!title) return '';
    return String(title).trim().split(/\s+/).slice(0, 2).join(' ');
  }

  // Normalize a video record into a product object. Accepts a nested
  // product/productInfo/productData object, or flat fields on the video itself.
  function resolveProduct(video) {
    var product = video.product || video.productInfo || video.productData || null;
    if (!product && (video.productTitle || video.title || video.productHandle || video.handle || video.price != null)) {
      product = {
        title: video.productTitle || video.title,
        handle: video.productHandle || video.handle,
        price: video.price,
        priceFormatted: video.priceFormatted,
        compareAtPrice: video.compareAtPrice || video.compare_at_price || video.mrp || video.originalPrice,
        compareAtPriceFormatted: video.compareAtPriceFormatted || video.mrpFormatted,
        image: video.productImage || video.image || video.imageUrl,
        variantId: video.variantId || video.variant_id
      };
    }
    // The variant id may arrive on the video (as a gid) rather than the
    // product. Normalize it to the numeric id /cart/add.js expects.
    if (product && !product.variantId) {
      var rawVariant = video.shopifyVariantId || video.variantId || video.variant_id
                     || product.shopifyVariantId || product.variantId;
      var numericVariant = gidToId(rawVariant);
      if (numericVariant) product.variantId = numericVariant;
    }
    return product;
  }

  function buildTile(video, idx) {
    var tile = document.createElement('button');
    tile.type = 'button';
    tile.className = 'shoppable-videos__tile';
    tile.setAttribute('role', 'listitem');
    tile.setAttribute('data-sv-tile', '');
    tile.setAttribute('data-sv-index', String(idx));

    var product = resolveProduct(video);
    var title = product && product.title;
    tile.setAttribute('aria-label', title ? 'Play video for ' + title : 'Play shoppable video');

    var media = document.createElement('span');
    media.className = 'shoppable-videos__tile-media';

    var v = document.createElement('video');
    v.className = 'shoppable-videos__tile-video';
    v.src = video.videoUrl;
    v.muted = true;
    v.loop = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('muted', '');
    v.preload = 'metadata';
    if (video.thumbnailUrl) v.poster = video.thumbnailUrl;
    if (title) v.setAttribute('aria-label', title);
    media.appendChild(v);

    // Product thumbnail, overlapping the bottom-left of the video (Quinn-style).
    var thumbSrc = product ? productImage(product, '') : '';
    if (thumbSrc) {
      var thumb = document.createElement('img');
      thumb.className = 'shoppable-videos__tile-thumb';
      thumb.src = thumbSrc;
      thumb.alt = title || '';
      thumb.loading = 'lazy';
      media.appendChild(thumb);
    }

    tile.appendChild(media);

    // Footer: product title + price below the video.
    if (product) {
      var footer = document.createElement('span');
      footer.className = 'shoppable-videos__tile-footer';

      if (title) {
        var titleEl = document.createElement('span');
        titleEl.className = 'shoppable-videos__tile-title';
        titleEl.textContent = displayTitle(title);
        footer.appendChild(titleEl);
      }

      var priceText = getPrice(product);
      var compareText = getComparePrice(product);
      if (priceText) {
        var priceEl = document.createElement('span');
        priceEl.className = 'shoppable-videos__tile-price';
        var cur = document.createElement('span');
        cur.className = 'shoppable-videos__tile-price-current';
        cur.textContent = priceText;
        priceEl.appendChild(cur);
        if (compareText) {
          var cmp = document.createElement('span');
          cmp.className = 'shoppable-videos__tile-price-compare';
          cmp.textContent = compareText;
          priceEl.appendChild(cmp);
        }
        footer.appendChild(priceEl);
      }

      tile.appendChild(footer);
    }

    return tile;
  }

  function setupTileAutoplayObserver(carousel) {
    if (prefersReducedMotion()) return null;
    if (!('IntersectionObserver' in window)) return null;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var vid = entry.target.querySelector('video');
        if (!vid) return;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          // Loop only the first 3 seconds on the rail: play 0→3s, restart.
          try { vid.currentTime = 0; } catch (e) {}
          var p = vid.play();
          if (p && p.catch) p.catch(function () {});
          if (vid._svPreviewTimer) clearInterval(vid._svPreviewTimer);
          vid._svPreviewTimer = setInterval(function () {
            try { vid.currentTime = 0; } catch (e) {}
            var rp = vid.play();
            if (rp && rp.catch) rp.catch(function () {});
          }, 3000);
        } else {
          if (vid._svPreviewTimer) {
            clearInterval(vid._svPreviewTimer);
            vid._svPreviewTimer = 0;
          }
          vid.pause();
        }
      });
    }, { root: carousel, threshold: [0, 0.6, 1] });

    return io;
  }

  /* ===== Reels-style modal ===== */

  function ReelsModal(root) {
    this.root = root;
    this.modal = root.querySelector('[data-sv-modal]');
    this.track = root.querySelector('[data-sv-reels-track]');
    this.soundBtn = root.querySelector('[data-sv-sound-toggle]');
    this.soundOnIcon = root.querySelector('[data-sv-sound-on]');
    this.soundOffIcon = root.querySelector('[data-sv-sound-off]');
    this.prevBtn = root.querySelector('[data-sv-prev]');
    this.nextBtn = root.querySelector('[data-sv-next]');
    this.layout = root.dataset.layout === 'horizontal' ? 'horizontal' : 'vertical';
    this.modal.setAttribute('data-sv-layout', this.layout);
    // The horizontal carousel is desktop-only; on mobile the player behaves
    // like the vertical reels (matches the CSS @media min-width: 750px gate).
    this.desktopMql = window.matchMedia('(min-width: 750px)');
    this._scrollRaf = 0;
    this.pdpProduct = {
      handle: root.dataset.productHandle || '',
      variantId: root.dataset.productVariantId ? parseInt(root.dataset.productVariantId, 10) : null,
      price: root.dataset.productPrice || '',
      compareAtPrice: root.dataset.productCompareAtPrice || '',
      image: root.dataset.productImage || ''
    };
    this.videos = [];
    this.reels = [];
    this.observer = null;
    this.currentIndex = -1;
    this.muted = false;
    this.savedTimes = {};
    this.lastFocus = null;

    var self = this;
    Array.prototype.forEach.call(root.querySelectorAll('[data-sv-modal-close]'), function (el) {
      el.addEventListener('click', function () { self.close(); });
    });
    document.addEventListener('keydown', function (e) {
      if (self.modal.hasAttribute('hidden')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        self.close();
      } else if (self.effectiveLayout() === 'horizontal' && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
        e.preventDefault();
        self.step(e.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    this.soundBtn.addEventListener('click', function () {
      self.setMuted(!self.muted);
    });
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () { self.step(-1); });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () { self.step(1); });
    }
    this.updateSoundIcon();
  }

  ReelsModal.prototype.setVideos = function (videos) {
    this.videos = videos || [];
  };

  // 'horizontal' only when the section is set to horizontal AND we're at a
  // desktop width; otherwise 'vertical' (mobile reels).
  ReelsModal.prototype.effectiveLayout = function () {
    return this.layout === 'horizontal' && this.desktopMql.matches ? 'horizontal' : 'vertical';
  };

  ReelsModal.prototype.buildReels = function () {
    this.track.innerHTML = '';
    this.reels = [];
    var self = this;

    this.videos.forEach(function (video, idx) {
      var reel = document.createElement('div');
      reel.className = 'shoppable-videos__reel';
      reel.setAttribute('data-sv-reel-index', String(idx));

      var v = document.createElement('video');
      v.className = 'shoppable-videos__reel-video';
      v.src = video.videoUrl;
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.muted = self.muted;
      if (self.muted) v.setAttribute('muted', '');
      v.preload = 'metadata';
      if (video.thumbnailUrl) v.poster = video.thumbnailUrl;
      reel.appendChild(v);

      // Tap on video toggles play/pause
      v.addEventListener('click', function () {
        if (v.paused) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });

      // Product card overlay — accept either video.product or flat fields on the video itself
      var product = resolveProduct(video);
      // Merge in PDP-injected values (variantId, compareAtPrice) since all reels are for the current product
      if (product && self.pdpProduct) {
        if (!product.variantId && self.pdpProduct.variantId) product.variantId = self.pdpProduct.variantId;
        if (!product.compareAtPrice && self.pdpProduct.compareAtPrice) product.compareAtPrice = self.pdpProduct.compareAtPrice;
        if (!product.handle && self.pdpProduct.handle) product.handle = self.pdpProduct.handle;
      }
      if (product && !product.handle) {
        var derivedHandle = extractHandleFromPaths(video.paths);
        if (derivedHandle) product.handle = derivedHandle;
      }

      if (product) {
        var card = document.createElement('div');
        card.className = 'shoppable-videos__reel-card';

        var imgSrc = productImage(product, video.thumbnailUrl);
        if (imgSrc) {
          var img = document.createElement('img');
          img.className = 'shoppable-videos__reel-card-img';
          img.src = imgSrc;
          img.alt = product.title || '';
          img.loading = 'lazy';
          card.appendChild(img);
        }

        var info = document.createElement('div');
        info.className = 'shoppable-videos__reel-card-info';

        var titleEl = document.createElement('p');
        titleEl.className = 'shoppable-videos__reel-card-title';
        titleEl.textContent = displayTitle(product.title);
        info.appendChild(titleEl);

        var priceText = getPrice(product);
        var compareText = getComparePrice(product);
        var priceEl = document.createElement('p');
        priceEl.className = 'shoppable-videos__reel-card-price';
        if (priceText) {
          var priceCurrent = document.createElement('span');
          priceCurrent.className = 'shoppable-videos__reel-card-price-current';
          priceCurrent.textContent = priceText;
          priceEl.appendChild(priceCurrent);
        }
        if (compareText) {
          var priceCompare = document.createElement('span');
          priceCompare.className = 'shoppable-videos__reel-card-price-compare';
          priceCompare.textContent = compareText;
          priceEl.appendChild(priceCompare);
        }
        info.appendChild(priceEl);
        card.appendChild(info);

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'shoppable-videos__reel-card-btn';
        btn.textContent = 'Add To Cart';
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (btn.disabled) return;
          btn.disabled = true;
          btn.textContent = 'Adding...';
          getVariantId(product).then(function (vid) {
            if (!vid) throw new Error('no variant resolved');
            return addToCart(vid);
          }).then(function (parsedState) {
            btn.textContent = 'Added';
            try {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            } catch (e) {}
            self.close();
            openCartDrawer(parsedState);
            setTimeout(function () {
              btn.textContent = 'Add To Cart';
              btn.disabled = false;
            }, 1500);
          }).catch(function (err) {
            log('shoppable-videos add-to-cart:', err);
            btn.textContent = 'Add To Cart';
            btn.disabled = false;
          });
        });
        card.appendChild(btn);

        reel.appendChild(card);
      }

      self.track.appendChild(reel);

      self.reels.push({
        video: video,
        videoEl: v,
        reelEl: reel
      });
    });
  };

  ReelsModal.prototype.setupActivation = function () {
    if (this.effectiveLayout() === 'horizontal') {
      this.setupScrollActivation();
    } else {
      this.setupObserver();
    }
  };

  // Horizontal layout: reels peek on both sides, so several intersect the
  // viewport at once. Pick the one whose centre is nearest the track centre.
  ReelsModal.prototype.setupScrollActivation = function () {
    var self = this;
    this.teardownScrollActivation();

    function pickNearest() {
      self._scrollRaf = 0;
      var center = self.track.scrollLeft + self.track.clientWidth / 2;
      var best = -1;
      var bestDist = Infinity;
      for (var i = 0; i < self.reels.length; i++) {
        var el = self.reels[i].reelEl;
        var elCenter = el.offsetLeft + el.clientWidth / 2;
        var dist = Math.abs(elCenter - center);
        if (dist < bestDist) { bestDist = dist; best = i; }
      }
      if (best !== -1 && best !== self.currentIndex) self.activate(best);
    }

    this._onScroll = function () {
      if (self._scrollRaf) return;
      self._scrollRaf = window.requestAnimationFrame(pickNearest);
    };
    this.track.addEventListener('scroll', this._onScroll, { passive: true });
    pickNearest();
  };

  ReelsModal.prototype.teardownScrollActivation = function () {
    if (this._onScroll) {
      this.track.removeEventListener('scroll', this._onScroll);
      this._onScroll = null;
    }
    if (this._scrollRaf) {
      window.cancelAnimationFrame(this._scrollRaf);
      this._scrollRaf = 0;
    }
  };

  ReelsModal.prototype.setupObserver = function () {
    if (this.observer) this.observer.disconnect();
    var self = this;
    this.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var idx = parseInt(entry.target.getAttribute('data-sv-reel-index'), 10);
        if (isNaN(idx)) return;
        var item = self.reels[idx];
        if (!item) return;

        if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
          self.activate(idx);
        } else {
          self.deactivate(idx);
        }
      });
    }, { root: this.track, threshold: [0, 0.5, 0.7, 1] });

    this.reels.forEach(function (entry) {
      self.observer.observe(entry.reelEl);
    });
  };

  ReelsModal.prototype.activate = function (idx) {
    if (this.currentIndex === idx) return;
    if (this.currentIndex !== -1) this.deactivate(this.currentIndex);

    this.currentIndex = idx;
    var entry = this.reels[idx];
    if (!entry) return;

    entry.reelEl.setAttribute('data-sv-active', '');
    // Horizontal layout: dock the sound toggle into the active tile's corner.
    if (this.effectiveLayout() === 'horizontal' && this.soundBtn) {
      entry.reelEl.appendChild(this.soundBtn);
    }
    this.updateNav();

    var v = entry.videoEl;
    var saved = this.savedTimes[idx];
    if (typeof saved === 'number' && !isNaN(saved)) {
      try { v.currentTime = saved; } catch (e) {}
    }
    v.muted = this.muted;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  };

  ReelsModal.prototype.deactivate = function (idx) {
    var entry = this.reels[idx];
    if (!entry) return;
    entry.reelEl.removeAttribute('data-sv-active');
    var v = entry.videoEl;
    if (!isNaN(v.currentTime)) this.savedTimes[idx] = v.currentTime;
    v.pause();
    if (this.currentIndex === idx) this.currentIndex = -1;
  };

  // Disable the prev/next arrows at the ends of the list (horizontal layout).
  ReelsModal.prototype.updateNav = function () {
    if (this.effectiveLayout() !== 'horizontal') return;
    if (this.prevBtn) this.prevBtn.disabled = this.currentIndex <= 0;
    if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= this.reels.length - 1;
  };

  // Scroll the requested reel into view; activation follows from the scroll
  // observer (horizontal) or the IntersectionObserver (vertical).
  ReelsModal.prototype.goTo = function (idx) {
    var entry = this.reels[idx];
    if (!entry) return;
    var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
    if (this.effectiveLayout() === 'horizontal') {
      var left = entry.reelEl.offsetLeft - (this.track.clientWidth - entry.reelEl.clientWidth) / 2;
      this.track.scrollTo({ left: left, top: 0, behavior: behavior });
    } else {
      this.track.scrollTo({ top: entry.reelEl.offsetTop, left: 0, behavior: behavior });
    }
  };

  ReelsModal.prototype.step = function (dir) {
    var base = this.currentIndex === -1 ? 0 : this.currentIndex;
    var next = base + dir;
    if (next < 0 || next >= this.reels.length) return;
    this.goTo(next);
  };

  ReelsModal.prototype.setMuted = function (muted) {
    this.muted = !!muted;
    this.reels.forEach(function (entry) {
      entry.videoEl.muted = muted;
    });
    this.soundBtn.setAttribute('aria-pressed', muted ? 'false' : 'true');
    this.updateSoundIcon();
  };

  ReelsModal.prototype.updateSoundIcon = function () {
    if (this.muted) {
      this.soundOnIcon.hidden = true;
      this.soundOffIcon.hidden = false;
    } else {
      this.soundOnIcon.hidden = false;
      this.soundOffIcon.hidden = true;
    }
  };

  ReelsModal.prototype.open = function (startIdx) {
    this.lastFocus = document.activeElement;
    this.modal.hidden = false;
    document.body.style.overflow = 'hidden';

    if (!this.reels.length) this.buildReels();

    var target = this.reels[startIdx];
    if (target) {
      // Jump to selected reel without smooth scroll first
      if (this.effectiveLayout() === 'horizontal') {
        var left = target.reelEl.offsetLeft - (this.track.clientWidth - target.reelEl.clientWidth) / 2;
        this.track.scrollTo({ left: left, top: 0, behavior: 'auto' });
      } else {
        this.track.scrollTo({ top: target.reelEl.offsetTop, left: 0, behavior: 'auto' });
      }
    }

    // Set up activation after positioning so the first pick lands on the target.
    this.setupActivation();
  };

  ReelsModal.prototype.close = function () {
    var self = this;
    this.reels.forEach(function (_, idx) {
      self.deactivate(idx);
    });
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    this.teardownScrollActivation();
    this.modal.hidden = true;
    document.body.style.overflow = '';
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  /* ===== Section init ===== */

  function init(root) {
    var baseUrl = root.dataset.backendBaseUrl;
    var shopDomain = root.dataset.shopDomain;
    var ctx = root.dataset.context;
    var targetId = root.dataset.targetId;
    var maxVideos = parseInt(root.dataset.maxVideos, 10) || 8;

    debug('init', { baseUrl: baseUrl, shopDomain: shopDomain, ctx: ctx, targetId: targetId, maxVideos: maxVideos });

    if (!baseUrl || !shopDomain) {
      log('shoppable-videos: missing backend base URL or shop domain');
      return;
    }

    if (ctx === 'product' && !targetId) {
      debug('aborting: product context but no targetId resolved');
      return;
    }
    if (ctx === 'collection' && !targetId) {
      debug('aborting: collection context but no targetId resolved');
      return;
    }

    fetchVideos(baseUrl, shopDomain, ctx, targetId).then(function (videos) {
      debug('fetched videos', { count: videos ? videos.length : 0 });
      if (!videos || !videos.length) {
        debug('no videos returned, section stays hidden');
        return;
      }

      var limited = videos.slice(0, maxVideos);
      var carousel = root.querySelector('[data-sv-carousel]');
      var modal = new ReelsModal(root);
      modal.setVideos(limited);
      var io = setupTileAutoplayObserver(carousel);

      limited.forEach(function (video, idx) {
        var tile = buildTile(video, idx);
        tile.addEventListener('click', function () { modal.open(idx); });
        carousel.appendChild(tile);
        if (io) io.observe(tile);
      });

      root.hidden = false;
      root.setAttribute('data-sv-visible', '');
      debug('rendered', limited.length, 'tile(s)');
    }).catch(function (err) {
      log('shoppable-videos:', err);
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-shoppable-videos]');
    debug('boot — section roots found:', roots.length);
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
